import axios from 'axios'

const getAll = () => {
    console.log("Getting blog posts")
    const request = axios.get(process.env.REACT_APP_FLASK_ENDPOINT + "blog_posts")
    return request.then(response => response.data.items)
  }

export default { getAll }